module.exports = __webpack_public_path__ + "static/media/abstract5.de4a53ff.jpg";